export default function HomeWorkProcess(){
    return(
        <section className="work-process-area">
			<div className="container">
				<ul className="process-bg">
					<li>
						<div className="work-process">
							<div className="process-icon">
								<img src="assets/img/icon/p-1a.png" alt="Process Icon" />
							</div>
							<h6>Putting data into<br />
								context</h6>
						</div>
					</li>
					<li>
						<div className="work-process">
							<div className="process-icon">
								<img src="assets/img/icon/p-1b.png" alt="Process Icon" />
							</div>
							<h6>Putting data into<br />
								context</h6>
						</div>
					</li>
					<li>
						<div className="work-process">
							<div className="process-icon">
								<img src="assets/img/icon/p-1c.png" alt="Process Icon" />
							</div>
							<h6>Putting data into<br />
								context</h6>
						</div>
					</li>
					<li>
						<div className="work-process">
							<div className="process-icon">
								<img src="assets/img/icon/p-1d.png" alt="Process Icon" />
							</div>
							<h6>Putting data into<br />
								context</h6>
						</div>
					</li>
				</ul>
			</div>
		</section>
    )
}